"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalTransport = void 0;
const Logger_1 = require("../utils/Logger");
const __1 = require("..");
const logger = new Logger_1.Logger('LocalTransport');
// Only used for testing
class LocalTransport extends __1.Transport {
    constructor() {
        super(...arguments);
        this.transformer = (message) => Promise.resolve(message);
    }
    static async isAvailable() {
        return Promise.resolve(false);
    }
    async send(message) {
        logger.log('send', message);
        const transformedMessage = this.transformer ? this.transformer(message) : message;
        await this.notifyListeners(transformedMessage, {});
        return;
    }
}
exports.LocalTransport = LocalTransport;
//# sourceMappingURL=LocalTransport.js.map